import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { CampoFormik } from '../../../CompUtils';
import FormSection from '../../../CompUtils/FormSection';
import { Formik } from 'formik';
import * as yup from 'yup';
import es from '../../../../yup-es';
import { Button, Col, Form, Table } from 'react-bootstrap';
import { CONCURSOAPI } from '../../../../const';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { finalize, init } from '../../../GlobalFeedback/feedbackSlice';
import { AlertaDialog } from '../../../CompUtils/Alerta';

yup.setLocale(es);
const initial = {
  isFE: false,
  isCI: true,
  f_DNDOSolicitud: '',
  DNDOnroSolicitud: '',
  f_DGYDCPSolicitud: '',
  DGYDCPNroSolicitud: '',
  f_DNDORespuesta: '',
  DNDOnroRespuesta: '',
  f_DGYDCPRespuesta: '',
  DGYDCPNroRespuesta: '',
  f_actaCOPIC: '',
  actaCOPICNroRespuesta: '',
};
//SCHEMA Y VALORES INICIALES
const FESchema = yup
  .object({
    isFE: yup.boolean().required(),
    isCI: yup.boolean(),
    f_DNDOSolicitud: yup.date(),
    DNDOnroSolicitud: yup.string(),
    f_DNDORespuesta: yup.date(),
    DNDOnroRespuesta: yup.string(),
    f_actaCOPIC: yup.date(),
    actaCOPICNroRespuesta: yup.string(),
  })
  .shape(
    {
      f_DNDORespuesta: yup.date().when('DNDOnroRespuesta', {
        is: (DNDOnroRespuesta) => !!DNDOnroRespuesta,
        then: yup.date().required(),
      }),

      DNDOnroRespuesta: yup.string().when('f_DNDORespuesta', {
        is: (f_DNDORespuesta) => f_DNDORespuesta,
        then: yup.string().required(),
      }),
    },
    ['f_DNDORespuesta', 'DNDOnroRespuesta'],
  )
  .shape(
    {
      f_DNDOSolicitud: yup.date().when('DNDOnroSolicitud', {
        is: (DNDOnroSolicitud) => !!DNDOnroSolicitud,
        then: yup.date().required(),
      }),

      DNDOnroSolicitud: yup.string().when('f_DNDOSolicitud', {
        is: (f_DNDOSolicitud) => f_DNDOSolicitud,
        then: yup.string().required(),
      }),
    },
    ['f_DNDOSolicitud', 'DNDOnroSolicitud'],
  )
  .shape(
    {
      f_DGYDCPRespuesta: yup.date().when('DGYDCPNroRespuesta', {
        is: (DGYDCPNroRespuesta) => !!DGYDCPNroRespuesta,
        then: yup.date().required(),
      }),

      DGYDCPNroRespuesta: yup.string().when('f_DGYDCPRespuesta', {
        is: (f_DGYDCPRespuesta) => f_DGYDCPRespuesta,
        then: yup.string().required(),
      }),
    },
    ['f_DGYDCPRespuesta', 'DGYDCPNroRespuesta'],
  )
  .shape(
    {
      f_DGYDCPSolicitud: yup.date().when('DGYDCPNroSolicitud', {
        is: (DGYDCPNroSolicitud) => !!DGYDCPNroSolicitud,
        then: yup.date().required(),
      }),

      DGYDCPNroSolicitud: yup.string().when('f_DGYDCPSolicitud', {
        is: (f_DGYDCPSolicitud) => f_DGYDCPSolicitud,
        then: yup.string().required(),
      }),
    },
    ['DGYDCPNroSolicitud', 'f_DGYDCPSolicitud'],
  )
  .shape(
    {
      f_actaCOPIC: yup.date().when('actaCOPICNroRespuesta', {
        is: (actaCOPICNroRespuesta) => !!actaCOPICNroRespuesta,
        then: yup.date().required(),
      }),

      actaCOPICNroRespuesta: yup.string().when('f_actaCOPIC', {
        is: (f_actaCOPIC) => f_actaCOPIC,
        then: yup.string().required(),
      }),
    },
    ['actaCOPICNroRespuesta', 'f_actaCOPIC'],
  );
export const IntervencionForm = ({ concurso = null, errorDTO }) => {
  const dispatch = useDispatch();
  const [isFE, setIsFE] = useState(false);
  const [isCI, setIsCI] = useState(false);
  const [alert, setAlert] = useState(false);
  const [concursoActual, setConcursoActual] = useState(concurso);

  const [datosACargarEnForm, setDatosACargarEnForm] = useState(initial);
  //ESTILOS
  const classes = createUseStyles({
    labelCell: {
      width: 150,
      verticalAlign: 'middle !important',
      textAlign: 'center',
    },
    dateCell: {
      width: 250,
    },
  })();

  const handleIsFE = (ev, formik) => {
    setIsFE(!isFE);
    formik.setFieldValue('isFE', ev.target.checked);
    if (!ev.target.checked) {
      formik.setFieldValue('f_DNDOSolicitud', '');
      formik.setFieldValue('DNDOnroSolicitud', '');
      formik.setFieldValue('f_DNDORespuesta', '');
      formik.setFieldValue('DNDOnroRespuesta', '');
    }
  };
  const handleIsCI = (ev, formik) => {
    setIsCI(!isCI);
    formik.setFieldValue('isCI', ev.target.checked);
    if (!ev.target.checked) {
      formik.setFieldValue('f_actaCOPIC', '');
      formik.setFieldValue('actaCOPICNroRespuesta', '');
    }
  };

  const handleSubmit = (values) => {
    var datos = {
      factaCopic: values.f_actaCOPIC !== '' ? values.f_actaCOPIC : null,
      fintervencionDgydcp: values.f_DGYDCPRespuesta !== '' ? values.f_DGYDCPRespuesta : null,
      fintervencionDndo: values.f_DNDORespuesta !== '' ? values.f_DNDORespuesta : null,
      fsolicitudDgydcp: values.f_DGYDCPSolicitud !== '' ? values.f_DGYDCPSolicitud : null,
      fsolicitudDndo: values.f_DNDOSolicitud !== '' ? values.f_DNDOSolicitud : null,
      nroActaCopic: values.actaCOPICNroRespuesta !== '' ? values.actaCOPICNroRespuesta : null,
      nroIntervencionDndo: values.DNDOnroRespuesta !== '' ? values.DNDOnroRespuesta : null,
      nroIntervencionDgydcp: values.DGYDCPNroRespuesta !== '' ? values.DGYDCPNroRespuesta : null,
      nroSolicitudDgydcp: values.DGYDCPNroSolicitud !== '' ? values.DGYDCPNroSolicitud : null,
      nroSolicitudDndo: values.DNDOnroSolicitud !== '' ? values.DNDOnroSolicitud : null,
      funcionEjecutiva: isFE,
      convocatoriaInterna: isCI,
    };

    dispatch(init());
    persistirDatos(datos);
    recuperarDatos();
    dispatch(finalize());
  };
  const recuperarDatos = () => {
    axios
      .get(
        `${CONCURSOAPI}/expedientellamadoconcurso/intervencion/${concurso.expedienteLlamadoConcurso.idExpedienteLlamadoConcurso}`,
      )
      .then((res2) => {
        poblarForm(res2.data);
      })
      .catch((error) => {
        if (error.response) {
          errorDTO(error.response.data.message || 'Error al intentar conectarse al servidor.');
        } else if (error.request) {
          errorDTO('Error de comunicación con el servidor');
        } else {
          errorDTO(error.message);
        }
      });
  };
  function poblarForm(datosRest) {
    setIsFE(datosRest.funcionEjecutiva);
    setIsCI(datosRest.convocatoriaInterna);

    datosACargarEnForm.f_actaCOPIC = datosRest.factaCopic ? datosRest.factaCopic : '';
    datosACargarEnForm.f_DGYDCPRespuesta = datosRest.fintervencionDgydcp
      ? datosRest.fintervencionDgydcp
      : '';
    datosACargarEnForm.f_DNDORespuesta = datosRest.fintervencionDndo
      ? datosRest.fintervencionDndo
      : '';
    datosACargarEnForm.f_DGYDCPSolicitud = datosRest.fsolicitudDgydcp
      ? datosRest.fsolicitudDgydcp
      : '';
    datosACargarEnForm.f_DNDOSolicitud = datosRest.fsolicitudDndo ? datosRest.fsolicitudDndo : '';
    datosACargarEnForm.actaCOPICNroRespuesta = datosRest.nroActaCopic ? datosRest.nroActaCopic : '';

    datosACargarEnForm.DNDOnroRespuesta = datosRest.nroIntervencionDndo
      ? datosRest.nroIntervencionDndo
      : '';

    datosACargarEnForm.DGYDCPNroRespuesta = datosRest.nroIntervencionDgydcp
      ? datosRest.nroIntervencionDgydcp
      : '';
    datosACargarEnForm.DGYDCPNroSolicitud = datosRest.nroSolicitudDgydcp
      ? datosRest.nroSolicitudDgydcp
      : '';
    datosACargarEnForm.DNDOnroSolicitud = datosRest.nroSolicitudDndo
      ? datosRest.nroSolicitudDndo
      : '';
  }
  const persistirDatos = (datos) => {
    const dataRequest = new FormData();

    dataRequest.append('expedienteLlamadoConcursoRequest', JSON.stringify(datos));
    axios
      .put(
        `${CONCURSOAPI}/expedientellamadoconcurso/intervencion/${concurso.expedienteLlamadoConcurso.idExpedienteLlamadoConcurso}`,
        datos,
      )
      .then((res) => {
        setAlert(true);
      })
      .catch((error) => {
        if (error.response) {
          errorDTO(error.response.data.message || 'Error al intentar conectarse al servidor.');
        } else if (error.request) {
          errorDTO('Error de comunicación con el servidor');
        } else {
          errorDTO(error.message);
        }
        throw new Error('Error al persistir los los datos de DNDO/DGYDCP.!');
      });
  };
  function closeAlert() {
    setAlert(false);
  }
  useEffect(() => {
    //concurso.expedienteLlamadoConcurso.idExpedienteLlamadoConcurso;
    if (concursoActual.tipoConcurso.idTipoConcurso === 1) setIsCI(true);

    if (concursoActual.tipoConcurso.funcionEjecutiva)
      setIsFE(concursoActual.tipoConcurso.funcionEjecutiva);
    recuperarDatos();
  }, []);

  return (
    <>
      <Formik
        validateOnChange={false}
        initialValues={initial}
        validationSchema={FESchema}
        onSubmit={handleSubmit}>
        {(formik) => (
          <Form noValidate onSubmit={formik.handleSubmit} id="designacionForm">
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Check
                  type="checkbox"
                  onBlur={formik.handleBlur}
                  onChange={(ev) => handleIsFE(ev, formik)}
                  checked={isFE}
                  label="Función ejecutiva"
                />
              </Form.Group>
              {/* <Form.Group as={Col}>
                <Form.Check
                  type="checkbox"
                  onBlur={formik.handleBlur}
                  onChange={(ev) => handleIsCI(ev, formik)}
                  checked={isCI}
                  label="Convocatoria interna"
                  disabled
                />
              </Form.Group> */}
            </Form.Row>
            <FormSection>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <td></td>
                    <td>Fecha</td>
                    <td>Solicitud Nro. Expediente (Providencia)</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={classes.labelCell}>DNDO</td>
                    <td className={classes.dateCell}>
                      <fieldset disabled={!isFE}>
                        <CampoFormik type="date" name="f_DNDOSolicitud" formik={formik} />
                      </fieldset>
                    </td>
                    <td>
                      <fieldset disabled={!isFE}>
                        <CampoFormik name="DNDOnroSolicitud" formik={formik} />
                      </fieldset>
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.labelCell}>DGYDCP</td>
                    <td className={classes.dateCell}>
                      <CampoFormik type="date" name="f_DGYDCPSolicitud" formik={formik} />
                    </td>
                    <td>
                      <CampoFormik name="DGYDCPNroSolicitud" formik={formik} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FormSection>
            <FormSection>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <td></td>
                    <td>Fecha</td>
                    <td>Respuesta Nro. Expediente (Providencia)</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={classes.labelCell}>DNDO</td>
                    <td className={classes.dateCell}>
                      <fieldset disabled={!isFE}>
                        <CampoFormik type="date" name="f_DNDORespuesta" formik={formik} />
                      </fieldset>
                    </td>
                    <td>
                      <fieldset disabled={!isFE}>
                        <CampoFormik name="DNDOnroRespuesta" formik={formik} />
                      </fieldset>
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.labelCell}>Acta Co.P.I.C</td>
                    <td className={classes.dateCell}>
                      <fieldset disabled={!isCI}>
                        <CampoFormik type="date" name="f_actaCOPIC" formik={formik} />
                      </fieldset>
                    </td>
                    <td>
                      <fieldset disabled={!isCI}>
                        <CampoFormik name="actaCOPICNroRespuesta" formik={formik} />
                      </fieldset>
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.labelCell}>DGYDCP</td>
                    <td className={classes.dateCell}>
                      <CampoFormik type="date" name="f_DGYDCPRespuesta" formik={formik} />
                    </td>
                    <td>
                      <CampoFormik name="DGYDCPNroRespuesta" formik={formik} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FormSection>
            <br />
            <br />
            <Button variant="success" type="submit">
              Guardar
            </Button>
          </Form>
        )}
      </Formik>
      <AlertaDialog size="sm" show={alert} onClose={closeAlert} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-success fa fa-check-circle-o"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>La información ha guardado correctamente</p>
        </div>
      </AlertaDialog>
    </>
  );
};
